module.exports = __webpack_public_path__ + "static/media/walletconnect.37f2bc6e.svg";